/*
 * Schlanke Ersatz-Helper für ehemals genutzte lodash-Funktionen.
 */
export function uniqBy(array, iteratee) {
    const seen = new Set()
    const keyOf = typeof iteratee === "function" ? iteratee : (item) => item[iteratee]
    return (array || []).filter((item) => {
        const key = keyOf(item)
        if (seen.has(key)) return false
        seen.add(key)
        return true
    })
}

export function keyBy(array, iteratee) {
    const keyOf = typeof iteratee === "function" ? iteratee : (item) => item[iteratee]
    return (array || []).reduce((map, item) => {
        map[keyOf(item)] = item
        return map
    }, {})
}

export function uniq(array) {
    return Array.from(new Set(array || []))
}

export function groupBy(array, iteratee) {
    const keyOf = typeof iteratee === "function" ? iteratee : (item) => item[iteratee]
    return (array || []).reduce((map, item) => {
        const key = keyOf(item)
        ;(map[key] = map[key] || []).push(item)
        return map
    }, {})
}

export function chunk(array, size) {
    const out = []
    const list = array || []
    for (let i = 0; i < list.length; i += size) {
        out.push(list.slice(i, i + size))
    }
    return out
}

export function omit(obj, keys) {
    const keySet = new Set(Array.isArray(keys) ? keys : [keys])
    return Object.fromEntries(Object.entries(obj || {}).filter(([k]) => !keySet.has(k)))
}

export function mapValues(obj, iteratee) {
    return Object.fromEntries(Object.entries(obj || {}).map(([k, v]) => [k, iteratee(v, k)]))
}

export function size(value) {
    if (value == null) return 0
    if (Array.isArray(value) || typeof value === "string") return value.length
    if (typeof value === "object") return Object.keys(value).length
    return 0
}